<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Certificados / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow">
                            <div class="card-header mt-1">
                                <span>Cliente: <strong>{{ client.name }}</strong></span>
                                <button class="btn btn-success float-right ml-3 mt-1" @click="showModalNewFile()"><i
                                        class="fa fa-plus"></i>
                                    Certificado</button>

                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-12 col-xs-12 col-lg-12">
                                        <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Descrição</th>
                                                    <th class="text-center">Vencimento</th>
                                                    <th class="text-center">Criado em</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="!filter_send_by_client">
                                                <tr v-for="(file, index) in files"
                                                    :key="index.id">
                                                    <td>{{ index + 1  }}</td>
                                                    <td>{{ file.description }}</td>
                                                    <td class="text-center">{{ file.overdue_formatted?file.overdue_formatted:'-' }}</td>
                                                    <td class="text-center">{{file.created_at }} </td>
                                                    <td>
                                                        <div class="dropdown">
                                                            <button class="btn btn-primary dropdown-toggle"
                                                                type="button" id="dropdownMenuButton"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false">
                                                                Ações
                                                            </button>
                                                            <div class="dropdown-menu animated--fade-in"
                                                                aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" href="#"
                                                                    @click="downloadFile(file.id)">Baixar arquivo</a>
                                                                <a class="dropdown-item" href="#"
                                                                    @click="showModalCreateCertificate(file.password)">Visualizar senha</a>
                                                                <a class="dropdown-item" href="#"
                                                                     @click="showModalEditCertificate(file.id)">Editar</a>
                                                                <a class="dropdown-item" href="#"
                                                                      @click="removeFile(file.id)">Remover</a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-show="files.length <= 0 && files.length <= 0">
                                                    <td colspan="6" class="text-center">Nenhum registro encontrado</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->


    <div id="modalDisplayNewFile" class="modal" :style="{ display: modalDisplayNewFile }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewFile">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Enviar certificado</h5>
                            <button type="button" class="close" @click="closeModalCreateCertificate()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: PDF Certificado XYZ"
                                        v-model="file.description">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label for="">Senha</label>
                                    <input type="text" class="form-control" placeholder="Ex: ******"
                                        v-model="file.password">
                                </div>
                                 <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label for="">Data vencimento</label>
                                    <input type="date" class="form-control"
                                        v-model="file.overdue">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <input type="file" @change="handleFileChange" accept=".pfx,.p12,.crt">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="file.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho: {{ file.size }}</small>
                                </div>
                            </div>
                            <div class="row mt-5" v-if="progressBarFile > 0">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar"
                                            :style="'width:' + progressBarFile + '%'" aria-valuenow="25"
                                            aria-valuemin="0" aria-valuemax="100">Progresso</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalCreateCertificate()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory" :disabled='!isDisabledFile'><i
                                    class="fa fa-save"></i>
                                Cadastrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div id="modalDisplayCertificate" class="modal" :style="{ display: modalDisplayCertificate }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewFile">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Senha certificado</h5>
                            <button type="button" class="close" @click="closeModalPassword()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Senha</label>
                                    <input disabled type="text" class="form-control" v-model="password_modal">
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalPassword()">Cancelar</button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayEditCertificate" class="modal" :style="{ display: modalDisplayEditCertificate }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateFile">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Atualizar dados certificado</h5>
                            <button type="button" class="close" @click="closeModalEditCertificate()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: PDF Certificado XYZ"
                                        v-model="file.description">
                                </div>
                            </div>
                             <div class="row mt-2">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label for="">Senha</label>
                                    <input type="text" class="form-control" placeholder="Ex: ******"
                                        v-model="file.password">
                                </div>
                                 <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label for="">Data vencimento</label>
                                    <input type="date" class="form-control"
                                        v-model="file.overdue">
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalEditCertificate()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory"
                                :disabled='!isDisabledFileUpdate'><i class="fa fa-save"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import tabMenuClient from './tab-menu-client.vue';
export default {
    components: { Loading, tabMenuClient },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            directories: {},
            files: {},
            modalDisplayNewFile: 'none',
            modalDisplayCertificate: 'none',
            modalDisplayEditCertificate: 'none',
            progressBarFile: 0,
            client_id: '',
            enable_error_list: false,
            errors: [],
            password_modal: '',
            file: {
                description: '',
                password: '',
                archive: null,
                client_id: '',
                size: '',
                overdue:'',
                certificate_id: ''
            }
        }
    },

    computed: {
        isDisabledFile: function () {
            return this.file.description != '' && this.file.archive != null;
        },
        isDisabledFileUpdate: function () {
            return this.file.description != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.getCertificateClient();
    },

    methods: {
        onCancel() { },
        getCertificateClient() {
            this.isLoading = true;
            api.get('/client/' + this.client_id + '/certificates')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.files = response.data.certificates;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 5) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 5MB",
                        type: 'info'
                    });
                    this.file.archive = null;
                } else {
                    this.file.archive = event.target.files[0];
                }
                this.file.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.file.size = '';
                this.file.archive = null;
            }

        },

        createNewFile(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            let formData = new FormData();
            formData.append('description', this.file.description);
            formData.append('password', this.file.password);
            formData.append('file', this.file.archive);
            if(this.file.overdue != ''){
               formData.append('overdue', this.file.overdue);
            }
            
            api.post('/client/' + this.client_id + '/certificate', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: progressEvent => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    this.progressBarFile = percentCompleted;
                }
            })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Certificado enviado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalCreateCertificate();
                    this.file = {};
                    this.file.archive = null;
                    this.file.size = '';
                    this.progressBarFile = 0;
                    this.getCertificateClient();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalCreateCertificate();
                    if (error.status == 422) {
                        this.getCertificateClient();
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

         updateFile(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/client/' + this.file.certificate_id + '/updateCertificate',this.file)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Certificado atualizado com sucesso!",
                        type: 'success'
                    });
                    this.closeModalEditCertificate();
                    this.file.certificate_id = '';
                    this.getCertificateClient();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalCreateCertificate();
                    if (error.status == 422) {
                        this.getCertificateClient();
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        removeFile(directory_id) {
            this.$confirm(
                {
                    message: 'Deseja remover o certificado?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/client/' + directory_id + "/certificate")
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Certificado excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.getCertificateClient();

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        async downloadFile(file_id) {
            this.isLoading = true;
            api.get('/client/' + file_id + '/downloadCertificate', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalCreateCertificate();
                    handleRequestErrors(error.status, error);
                })
        },

        showModalNewFile() {
            this.modalDisplayNewFile = 'block';
        },
        showModalCreateCertificate(password) {
            this.password_modal = password;
            this.modalDisplayCertificate = 'block';
        },
        closeModalCreateCertificate() {
            this.modalDisplayNewFile = 'none';
        },
        closeModalPassword() {
            this.modalDisplayCertificate = 'none';
        },
        showModalEditCertificate(certificate_id) {
            this.files.forEach(certificate => {
                if (certificate.id == certificate_id) {
                    this.file.description = certificate.description;
                    this.file.password = certificate.password;
                    this.file.overdue = certificate.overdue;
                    this.file.certificate_id = certificate_id;
                    this.modalDisplayEditCertificate = 'block';
                }
            });

        },
        closeModalEditCertificate() {
            this.file.description = '';
            this.file.password = '';
            this.file.overdue = '';
            this.modalDisplayEditCertificate = 'none';
        },

    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>